import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#1f2647',
    light: '#cbd5de',
    dark: '#011f3a',
  },
  secondary: {
    main: '#fff6a1',
    light: '#fffdea',
    dark: '#a39d63',
  },
  error: {
    main: '#9E1E19',
    light: '#ebd1d0',
    dark: '#661411',
  },
  success: {
    main: '#007505',
    light: '#cae2cb',
    dark: '#014b04',
  },
  warning: {
    main: '#e5c100',
    light: '#faf2c9',
    dark: '#957e01',
  },
  info: {
    main: '#0065C1',
    light: '#d2e4f4',
    dark: '#01407a',
  },
};
